import { gql } from "@apollo/client";

export const EVENT_DATA_FRAGMENT = gql`
	fragment EventData on User {
		id
		activeBoost {
			id
		}
		lastBoost {
			id
		}
		notificationCounts {
			likesMutual
			likesIncoming
			messages
		}
		notifications {
			type
			title
			subtitle
			redirectPathURL
			isViaSpotlight
			target {
				... on Match {
					user {
						id
						primaryImage {
							id
							square225
						}
					}
				}
				... on MatchPreview {
					primaryImageBlurred {
						square225
					}
				}
			}
		}
	}
`;

export const GET_EVENT_DATA_QUERY = gql`
	${EVENT_DATA_FRAGMENT}

	query eventDataForPage($userid: String!) {
		user(id: $userid) {
			...EventData
		}
	}
`;

export const MARK_BOOST_REPORT_SEEN_MUTATION = gql`
	${EVENT_DATA_FRAGMENT}

	mutation markBoostReportSeen($input: MarkBoostReportSeenInput!) {
		markBoostReportSeen(input: $input) {
			user {
				...EventData
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/util/fragments.js